import ExclamationPointIcon from '@/assets/images/icon-exclamation-point.svg?react';
import {DocumentForm} from '@/interfaces/document';
import {useDocumentLocale} from '../hooks';

type PdfVisualizerProps = {
  onLoaded?: (type: string) => void;
  documentId: string;
  form: DocumentForm;
  secure?: boolean;
};

export const PdfVisualizer = ({onLoaded, form}: PdfVisualizerProps) => {
  const {t} = useDocumentLocale();

  if (!form.content)
    return (
      <div className="mx-auto flex min-h-document-content-min-height w-full max-w-60 flex-col items-center justify-center gap-4 text-center">
        <ExclamationPointIcon className="size-16 shrink-0 rounded-full bg-grey-675 fill-white" />
        {t('constants.feedback-message.default.error')}
      </div>
    );

  return (
    <iframe
      // eslint-disable-next-line i18next/no-literal-string
      title={`PDF - ${form.type} - ${form.filename}`}
      className={'flex min-h-document-content-min-height flex-1'}
      src={`data:application/pdf;base64,${form.content}`}
      onLoad={() => onLoaded?.(form.type)}
    />
  );
};
